import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import UserAuthListComponent from '../components/userAuthListComponent';
import { fetchHeartRunnerDetail,
        
       getAllRegionSettings,getAuthMethodFunc,getAuthTypeFunc,AddUserAuthenticationSetting
        } from '../action/userAuthListAction';
import {getCountryListFunc,getRegionListFunc} from '../../SuperAdminManagement/HeartRunner/actions/heartRunnerAction';

class UserAuthListContainer extends Component {
    
    componentWillMount() {
        let OrganizationID=this.props.match.params.id
        
           /*  this.props.actions.fetchHeartRunnerDetail(
                OrganizationID,
            this.props.dispatch) */
              this.props.actions.getAllRegionSettings();
    }
    componentDidMount() {
     
         this.props.actions.getRegionListFunc(
        this.props.dispatch)
        this.props.actions.getAllRegionSettings();
       
                this.props.actions.getAuthTypeFunc(
                    this.props.dispatch
                )
                this.props.actions.getAuthMethodFunc(
                    this.props.dispatch
                )
    }
      getRegion = () =>{
            this.props.actions.getAllRegionSettings(
                this.props.dispatch
            )
            
        }
      
       getRegionData = () => {
              this.props.actions.getAllRegionSettings(this.props.dispatch);
           } 
      
        getUserList = (data) =>{
            this.props.actions.fetchHeartRunnerDetail(data,
                this.props.dispatch
            )
        }
      
       getUserListData = (data) => {
              this.props.actions.fetchHeartRunnerDetail(data,this.props.dispatch);
           }
    getList=() =>{
        let OrganizationID=this.props.match.params.id
        this.props.actions.fetchHeartRunnerDetail(
            OrganizationID,
        this.props.dispatch)
    }
    onDelete=(data,regionId)=> {
        
        this.props.actions.AddUserAuthenticationSetting(
            this.props.heartRunnerList.isLoading,
            data,regionId,
            this.props.dispatch
            )
    }

    getUserList = (data) =>{
            this.props.actions.fetchHeartRunnerDetail(data,
                this.props.dispatch
            )
        }
    render() {
        return (
            <div className="agile-grids">
                <div className="grids">
                    <div className="container">
                        <div className="row">
                            
                            <UserAuthListComponent
                                heartRunnerList={this.props.heartRunnerList}
                               
                                onDelete={this.onDelete}
                                updateAlarmSettings={this.updateAlarmSettings}
                               
                                getList = {this.getList}
                              
                                getRegion ={this.getRegion}
                    getRegionList={this.getRegionData}
                    getUserList ={this.getUserList}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            fetchHeartRunnerDetail, 
            
            getRegionListFunc,
            getAllRegionSettings,getAuthMethodFunc,getAuthTypeFunc,AddUserAuthenticationSetting
        }, dispatch)
    };
};

function mapStateToProps({UserAuthListReducer}) {
   console.log('dd',UserAuthListReducer)
    return {
        heartRunnerList: {
            //isLoading: UserAuthListReducer.isLoading,
            heartRunnerList:UserAuthListReducer.heartRunnerList,
            errorNumber: UserAuthListReducer.errorNumber,
            errorMessage:UserAuthListReducer.errorMessage,
            messageLabel: UserAuthListReducer.messageLabel,
            statusCode:UserAuthListReducer.statusCode,
            regionList :UserAuthListReducer.regionList,
            permissionList:UserAuthListReducer.permissionList,
            regionList :UserAuthListReducer.regionList,
            authenticationTypeList:UserAuthListReducer.authenticationTypeList,
            authenticationMethodList:UserAuthListReducer.authenticationMethodList
        },
        
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserAuthListContainer))